import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import checked from '../../../imges/settled/checked.png';
import API from '../../../server/index';
import { Form, Input, Typography, Select, Checkbox } from 'antd';
import { FormInstance } from 'antd/lib/form';
import 'antd/dist/antd.css';
import Toast from '../../../component/toast';

const { Text } = Typography;
const { Option } = Select;

const Step1 = (props: any) => {
  const { stepStore } = props ?? {};
  const [category, setCategory] = useState<any[]>([]);
  const [currentCategory, setCurrentCategory] = useState<any[]>([]);
  const [managers, setManagers] = useState<any[]>([]);
  const [categoryColor, setCategoryColor] = useState<string>('#0000001F');
  const [managerNameColor, setManagerNameColor] = useState<string>('#0000001F');
  const [isAgree, setIsAgree] = useState(false);
  const [noChoice, setNoChoice] = useState<boolean>(false);
  const [categoryManager, setCategoryManager] = useState<{categoryName:string, managerName:string}[]>([]);
  const formRef = React.createRef<FormInstance>();
  useEffect(() => {
    getCategoryManager()
    window.parent.postMessage({height: '21.67rem', type: 'height'},"*");

  }, []);
  useEffect(() => {
    if (currentCategory.length === 0) {
      setManagers([]);
    } else {
      let myString = '';
      for (const cate of currentCategory) {
        const manager = categoryManager.find((value) => {
          return value.categoryName === cate;
        });
        myString += `${manager?.managerName},`;
      }
      if (myString.length > 0) {
        myString = myString.substring(0, myString.length - 1);
      }
      const mySet: any = new Set(myString.split(','));
      setManagers(Array.from(mySet));
    }
  }, [currentCategory, categoryManager]);
  const getCategoryManager = async () => {
    const resData = await API.ApiFindCategoryManager25745();
    const _temp = resData.data.map(item => {
      return {
        label: item.categoryName,
        value: item.categoryName,
      }
    });
    setCategory(_temp)
    setCategoryManager(resData.data ?? []);
  }
  const formChange = (values: any) => {
    if (values.category) {
      setCurrentCategory(values.category)
      formRef.current?.setFieldsValue({ ...formRef.current.getFieldsValue(), managerName: [] });
    } else if (values.managerName) {
      setNoChoice(false);
    }

  }

  const rulesFunc = (value: any, title: string, setFunc: any) => {
    if (!value || value.length === 0) {
      setFunc('#ff4d4f');
      return Promise.reject(<Text type='danger'>{title}</Text>)
    }
    setFunc('#0000001F')
    return Promise.resolve();
  }

  const getForm = (label: string, name: string, _isleft: boolean, rules?: any[]) => {
    const myRules = rules ? rules : [];
    return <Form.Item label={<Text style={{ fontSize: '14px', color: '#788399FF', lineHeight: '18px' }}  >{label}</Text>}
      name={name}
      style={{ width: '84vw' }}
      rules={[{ required: true, message: `请输入${label}` }, ...myRules]}>
      <SInput />
    </Form.Item>
  }
  const noChoiceAction = (_value: any) => {
    if (!noChoice) {
      formRef.current?.setFieldsValue({ ...formRef.current.getFieldsValue(), managerName: [] });
      setManagerNameColor('#0000001F');
    }
    setNoChoice(!noChoice);
  }
  const confirm = async () => {
    const values = await formRef.current?.validateFields();
    if (!isAgree) {
      Toast('请阅读并同意遥望平台账号用户协议和隐私政策');
      return;
    }
    const { companyName, mainBrand, category, name, mobile, wx, managerName } = values;
    const resData = await API.ApiCheckSupplyName11900({ companyName: companyName });
    if (resData.data.exist === 1) {
      Toast('此公司已申请过商家入驻，请检查公司名称是否填写正确');
      return;
    }
  
    let params: any = {
      companyName: companyName.trim(),
      mainBrand,
      category: (category ?? []).join(','),
      name,
      mobile,
      wx
    };
    if (noChoice) {
      params.noManager = true;
    } else {
      params.managerName = (managerName ?? []).join(',');
    }
    await API.ApiMerchantsSettle11080(params);
    stepStore.changeThisStep(3);
  }

  return (
    <Container>
      <Text style={{ fontSize: '30px', color: '#3E3F3F', marginTop: '5.2vw', margin: "5.2vw 0 5.8vw" }}>供应商入驻申请</Text>
      <div style={{width: '84vw'}}>
        <Form layout="vertical" ref={formRef} onValuesChange={formChange} autoComplete='off'>
          {getForm('公司名称', 'companyName', true, [{ pattern: /^.{1,50}$/, message: '请输入50字以内的公司名称' }])}
          {getForm('主营品牌', 'mainBrand', true)}
          <Form.Item
            validateStatus=''
            label={<Text style={{ fontSize: '14px', color: '#788399FF', lineHeight: '18px' }}  >主营类目</Text>}
            name='category'
            required={true}
            style={{ width: '84vw' }}
            rules={[
              () => ({
                validator(_, value) {
                  return rulesFunc(value, '请选择主营类目', setCategoryColor);
                },
              }),]}
          >
            <SSelect style={{ borderBottomColor: categoryColor }} bordered={false} mode='multiple' allowClear showArrow showSearch={false}>
              {
                category && category.map((item) => {
                  return <Option value={item.value} key={item.value}>{item.label}</Option>
                })
              }
            </SSelect>
          </Form.Item>
          {getForm('联系姓名', 'name', false, [{ pattern: /^[\u4e00-\u9fa5a-zA-Z\s]{1,30}$/, message: '请输入正确的联系姓名' }])}
          {getForm('联系电话', 'mobile', true, [{ pattern: /^[1]\d{10}$/, message: '请输入11位的联系电话' }])}
          {getForm('微信账号', 'wx', false, [{ pattern: /^.{1,20}$/, message: '请输入正确的微信号' }])}
            <Form.Item label={<Text style={{ fontSize: '14px', color: '#788399FF', lineHeight: '18px' }}  >遥望招商对接人</Text>}
              name='managerName'
              style={{ width: '84vw' }}
              validateStatus=''
              required={true}
              rules={[
                () => ({
                  validator(_, value) {
                    if (noChoice) {
                      setManagerNameColor('#0000001F');
                      return Promise.resolve();
                    } else {
                      return rulesFunc(value, '请选择遥望招商对接人', setManagerNameColor);
                    }
                  }
                }),]}
            >
              <SSelect mode='multiple' style={{ borderBottomColor: managerNameColor }} allowClear bordered={false} notFoundContent={<Text style={{ fontSize: '15px' }} type='secondary'>请先选择主营类目</Text>} showArrow showSearch={false} >
                {
                  managers.map((item) => {
                    return <Option  value={item} key={item}>{item}</Option>
                  })
                }
              </SSelect>
            </Form.Item>
            <Form.Item>
              <Checkbox style={{fontSize:'12px'}} onChange={noChoiceAction} checked={noChoice}>暂无遥望招商对接人</Checkbox>
            </Form.Item>
        </Form>
      </div>
      <Button  onClick={confirm}>提交申请</Button>
      <Agreement isAgree={isAgree}>
        <label onClick={() => {
          setIsAgree(!isAgree);
        }} />
        <span>
          我已阅读并同意遥望平台账号
        <a href='http://cdn.ywwl.com/download/ywwl_userRegisterProtocol.pdf'
            rel='noopener noreferrer'
            target='_blank'>用户协议</a>
        和
        <a href='http://cdn.ywwl.com/download/ywwl_privacyPolicies.pdf'
            rel='noopener noreferrer'
            target='_blank'>隐私政策</a>
        </span>
      </Agreement>
    </Container>
  )
}

export default Step1;

const Container = styled.div`
  width: 93.33vw;
  background: #fff;
  margin-top:3.33vw;
  border-radius: 8px;
  display: flex;
  flex-direction:column;
  align-items: center;
  padding-bottom: 6.8vw;
  margin-bottom: 6.8vw;
  .ant-checkbox-inner{
    // 设置 checkbox 的大小
    width: 12px;
    height: 12px;
}
`

const SInput = styled(Input)`
 font-size: 15px;
  height: 39px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  outline: none;
  color:rgba(0, 0, 0, 0.87);
  &:focus{
     border: none;
     border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
`

const SSelect = styled(Select)`
  min-height: 39px;
  line-height:20px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  outline: none;
  
  &:focus{
     border: none;
     border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
`



const Button = styled.button`
  width: 89.3vw;
  height:40px;
  margin-top: 12.26vw;
  font-size:18px;
  outline: none;
  background: #1968FC;
  border-radius: 8px;
  border: 1px solid #216DF3;
  color: #ffffff;
`

const agree = css`
  label{
    background: white url(${checked}) center center / 10px 10px no-repeat;
  }
`
const Agreement = styled.div`
  user-select: none;
  text-align: center;
  margin-top: 25px;
  color: #75839B;
  label{
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    height: 14px;
    width: 14px;
    border-radius: 50%;
    border: 1px solid #1890FF;
  }
  ${({ isAgree }: { isAgree: boolean }) => (
    isAgree ? agree : ''
  )}
  span{
    vertical-align: middle;
    display: inline-block;
    a{ 
        font-size:12px;
        font-weight:400;
        color:#1968FC;
        line-height:17px;
        text-decoration: none;
      }
  }
`
